import { Component, inject, resource } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../../../services/api.service';
import { LanguageService } from '../../../services/language.service';
import { SlugService } from '../../../services/slug.service';
import { ButtonComponent } from '../../common/button/button.component';
import { LanguageSelectionComponent } from '../../common/language-selection/language-selection.component';
import { SocialMediaLinksComponent } from '../../common/social-media-links/social-media-links.component';
import { MapComponent } from '../../common/map/map.component';
import { Footer } from '../../../types/footer.types';
import { NavbarService } from '../../../services/navbar.service';

@Component({
    selector: 'app-footer-apartment',
    templateUrl: './footer-apartment.component.html',
    imports: [
        SocialMediaLinksComponent,
        LanguageSelectionComponent,
        RouterLink,
        ButtonComponent,
        MapComponent,
        TranslatePipe,
    ],
})
export class FooterApartmentComponent {
    languageService = inject(LanguageService);
    slugService = inject(SlugService);
    navbarService = inject(NavbarService);
    private apiService: ApiService = inject(ApiService);
    footerData = resource({
        request: this.languageService.languageCode,
        loader: () =>
            firstValueFrom<Footer>(
                this.apiService.getApartmentFooter(
                    this.languageService.languageCode(),
                ),
            ),
    });
}
